export default __webpack_public_path__ + "static/media/Arrow white.685c7630.svg";